var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2667 3.19092H17.5637V14.6455H10.2667V3.19092Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0303 8.91809C11.0303 6.709 12.1333 4.58173 13.9151 3.19082C10.8606 0.818094 6.36361 1.22718 3.73331 4.009C1.10301 6.79082 1.01816 11.0454 3.73331 13.8272C6.44846 16.609 10.8606 16.9363 14 14.6454C12.1333 13.2545 11.0303 11.1272 11.0303 8.91809Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2182 8.91826C26.2182 11.7001 24.5212 14.2364 21.9758 15.4637C19.4303 16.691 16.2909 16.3637 14 14.6455C15.8667 13.2546 16.8848 11.1274 16.8848 8.91826C16.8848 6.70917 15.7818 4.5819 14 3.19099C16.2909 1.47281 19.3455 1.14554 21.9758 2.37281C24.6061 3.60008 26.2182 6.13645 26.2182 8.91826Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6243 13.909V13.2545H25.794V13.0908H25.4546V13.2545H25.6243V13.909ZM26.3031 13.909V13.0908H26.2182L26.1334 13.6635L25.9637 13.0908H25.8788V13.909H25.9637V13.2545L26.0485 13.7454H26.1334L26.2182 13.2545L26.3031 13.909Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.5979e934ab35c5177a9008a5cc91a68a.svg";
export { ForwardRef as ReactComponent };